module.exports = "img/13.cb1c1a.webp";